import { render, staticRenderFns } from "./ElementarySchoolChineseCourse.vue?vue&type=template&id=5054675b&scoped=true&"
import script from "./ElementarySchoolChineseCourse.vue?vue&type=script&lang=js&"
export * from "./ElementarySchoolChineseCourse.vue?vue&type=script&lang=js&"
import style0 from "./ElementarySchoolChineseCourse.vue?vue&type=style&index=0&id=5054675b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5054675b",
  null
  
)

export default component.exports